import axios from 'axios';

// Используем относительный URL — браузер сам подставит текущий хост.
//
// Реальный случай (регрессия после фикса Edge-бага в UploadPage.tsx):
// жёстко заданный здесь Content-Type: application/json ломает загрузку
// файлов — axios 1.x при теле FormData проверяет уже выставленный
// Content-Type, и если это "application/json", сериализует FormData в
// JSON-СТРОКУ вместо настоящего multipart-тела с boundary (см.
// node_modules/axios/lib/defaults/index.js, transformRequest,
// hasJSONContentType). Сервер получает JSON с этим же заголовком и падает
// с "Current request is not a multipart request". Задавать Content-Type
// тут не нужно вообще — axios сам корректно проставляет
// "application/json" для обычных JS-объектов и "multipart/form-data;
// boundary=..." для FormData, если инстанс не мешает своим дефолтом.
const api = axios.create({
  baseURL: '/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;